import type { Database } from '@/integrations/supabase/types';

export type SubscriptionTier = Database['public']['Enums']['subscription_tier'];
export type SubscriptionStatus = Database['public']['Enums']['subscription_status'];
export type SubscriptionPlan = Database['public']['Enums']['subscription_plan'];

export type CheckoutPlan = 'monthly';

export interface SubscriptionProfileFields {
  subscription_tier: SubscriptionTier;
  subscription_status: SubscriptionStatus | null;
  subscription_plan: SubscriptionPlan | null;
  subscription_expires_at: string | null;
  stripe_customer_id: string | null;
  successful_statement_imports: number;
}

export function isPremiumUser(
  profile: SubscriptionProfileFields | null | undefined,
  isAdmin: boolean,
): boolean {
  if (isAdmin) return true;
  return profile?.subscription_tier === 'premium';
}

export function getPlanLabel(plan: SubscriptionPlan | null): string {
  if (plan === 'monthly') return 'Premium';
  // Compatibilidad legacy: perfiles antiguos con subscription_plan = 'annual'
  // siguen siendo Premium mientras el enum de BD conserve el valor.
  if (plan === 'annual') return 'Premium';
  return 'Gratuito';
}

export function getStatusLabel(status: SubscriptionStatus | null): string | null {
  if (status === 'past_due') return 'Pago pendiente — actualiza tu tarjeta';
  if (status === 'cancelled') return 'Cancelada';
  if (status === 'active') return 'Activa';
  return null;
}

export const PRICING = {
  monthly: { amount: 19.99, label: '$19.99/mes' },
} as const;
